// import Vue from 'vue';

// 后续需要添加行为记录
export default {
  beforeRouteEnter(to, from, next) {
    // 路由行为记录
    // Vue.prototype.$recordUserAct({ pageId: to.fullPath });

    next();
  }
};



// WEBPACK FOOTER //
// ./src/utils/mixins/navigateMixin.js